import * as GottiClient from '@gotti/client';
import * as GottiServer from '@gotti/server';
import * as GottiCore from '@gotti/core';
import * as GottiPlayground from '@gotti/playground/browser';
import * as TestUtils from '@gotti/test-utils';
import * as BrowserTestUtils from '@gotti/test-utils/harness-browser';

/**
 * The packages a project's files import by name, as the in-browser project loader (`ProjectLoader`) hands them out:
 * the real framework modules (`@gotti/systems` is `@gotti/core`, as the v1 loader always gave it), `@gotti/playground`
 * as its browser entry — what a page can run — and `@gotti/test-utils` with its browser harness winning on a name both
 * export, as in the test runner's module map. The live preview and the Tests panel load a project through this map.
 * It lives in the app, not in `@gotti/sandbox-test`, which keeps static imports of other `@gotti` packages out of its
 * build (see `sandboxPlayground.ts`).
 */
export function sandboxExternals(): Map<string, unknown> {
  return new Map<string, unknown>([
    ['@gotti/client', GottiClient],
    ['@gotti/server', GottiServer],
    ['@gotti/core', GottiCore],
    ['@gotti/systems', GottiCore],
    ['@gotti/playground', GottiPlayground],
    ['@gotti/test-utils', { ...TestUtils, ...BrowserTestUtils }],
  ]);
}
